/* eslint-disable */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-case-declarations */
/* eslint-disable prefer-template */
/* eslint-disable no-param-reassign */
import wx from 'weixin-js-sdk';
import { Toast, Modal } from 'antd-mobile';
import api from 'Api';

// 获取url？后面的 参数 转为对象
const getUrlParams = (search)=>{
  const res = {};
  let url = window.location.search.substr(1);
  if(search){
    url = search.substr(1);
  }
  const params = url.split('&');
  if(params){
    params.forEach((param) => {
      const index = param.indexOf('=');
      const paramArr = [];
      paramArr[0] = param.substring(0,index);
      paramArr[1] = param.substring(index + 1);
      if(paramArr[0]){
        res[paramArr[0]] = paramArr[1];
      }
    });
  }
  return res;
};

const jsonParse = data => {
  try {
    return JSON.parse(data);
  } catch (e) {
    return {};
  }
};

// 计算带小数点价钱 的 产品 的 总价
const sumPrice = (price, num)=>{
  const price1 = String(price);
  let floatNum = 0;
  const price1Arr = price1.split('.');
  if (price1Arr[1]) {
    price1Arr[1].split('').forEach(()=>{
      floatNum += 1;
    });
  }
  // eslint-disable-next-line no-restricted-properties
  return Number(price1.replace(".","")) * Number(num) / Math.pow(10,floatNum);  
};

// 微信分享配置
const wxShareConfig = (params = {})=>{
  const {searchParam} = params;
  const title = params.title || '首客首享';
  const desc = params.desc || '首客首享';
  const link = params.link || '';
  const imgUrl = params.imgUrl || 'http://image-1253289665.picsh.myqcloud.com/2020/02/21/b2a92b8b67c27644646e52e07d052d9f.png';
  const call = () => {};
  const callback = params.callback || call;
  const noTimeline = params.noTimeline || false;
  wx.showOptionMenu();
  const menuList = [
    'menuItem:readMode',
    'menuItem:copyUrl',
    'menuItem:share:qq',
    'menuItem:share:weiboApp',
    'menuItem:favorite',
    'menuItem:share:facebook',
    'menuItem:share:QZone',
    'menuItem:share:email',
    'menuItem:openWithSafari',
    'menuItem:openWithQQBrowser'
  ];
  if(noTimeline){
    menuList.push('menuItem:share:timeline');
  }
  wx.hideMenuItems({
    menuList
  });
  let linkUrl = `${window.location.protocol}//${window.location.host}/wechat-v2/v2/build/index.html?v=2#${link}`;
  if(searchParam){
    linkUrl = `${window.location.protocol}//${window.location.host}/wechat-v2/v2/build/index.html?v=2&${  searchParam  }#${ link}`;
  }
  wx.onMenuShareAppMessage({
    title, // 分享标题
    desc, // 分享描述
    link: linkUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl, // 分享图标
    type: 'link', // 分享类型,music、video或link，不填默认为link
    success: ()=>{
      callback();
    }
  });
  if(!noTimeline){
    wx.onMenuShareTimeline({
      title, // 分享标题
      link: linkUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl, // 分享图标
      success: ()=>{
        callback();
      },
    });
  }
  if (window.sayhi.isBtgApp) {
    const { shareType, miniPath, shareUrl } = params;
    window.sayhi.sub('clickShareNative', () => {
      window.sayhi.pub('onAppCallShare', {
        shareType,
        miniPath,
        shareUrl,
        title,
        thumbUrl: imgUrl,
        success() {
          callback();
        },
      });
    });
  }
  
};
// 
const admaster = (data) => {
  // 获取性别
  const getGender = (gender) => {
    let genderStr = '未知';
    if (Number(gender) === 1) {
      genderStr = '男';
    } else if (Number(gender) === 2) {
      genderStr = '女';
    }
    return genderStr;
  };

  // 获取用户类型
  const getUserType = (type) => {
    let userType = '普通用户';
    if (Number(type) === 2) {
      userType = '内部推荐';
    } else if (Number(type) === 3) {
      userType = '员工会员';
    }
    return userType;
  };

  // 获取用户生日
  const getUserBirthday = (timestamp) => {
    if (timestamp) {
      const time = new Date(Number(timestamp));
      const year = time.getFullYear();
      const month = (time.getMonth() + 1) < 10 ? `0${  time.getMonth() + 1}` : (time.getMonth() + 1);
      const day = time.getDate() < 10 ? `0${  time.getDate()}` : time.getDate();
      return `${year  }-${  month  }-${  day}`;
    }
    return '';
  };

  // 获取用户地址
  const getUserAddress = positionInfo => {
    const { province, city, area } = positionInfo;
    if (province === city) {
      return `${city}${area}`;
    }
    return `${province}${city}${area}`;
  };

  const userInfo = data;
  if (window._sksx) {
    // 绑定用户openid
    window._sksx.push(['_identify', userInfo.user_relation.openid]);
    // 获取用户信息
    window._sksx.push(['_profile', {
      userid: userInfo.user.id,
      openid: userInfo.user_relation.openid,
      nickname: userInfo.user.realname,
      sex: getGender(userInfo.user.gender),
      birthday: getUserBirthday(userInfo.user.birthday),
      city: getUserAddress(userInfo.user_relation),
      usertype: getUserType(userInfo.user.type),
      userlevel: userInfo.user_level.level_name,
      avatar: userInfo.user.avatar,
      grow: userInfo.user.grow,
      point: userInfo.user.point,
      is_active: userInfo.user.is_active,
      invite_friends: userInfo.user.invite_friends_num
    }]);
  }
};
//  微信 打开 地图
const wxOpenLocation = (addObj) => {
  wx.openLocation({
    latitude: parseFloat(addObj.latitude) || 39.915, // 纬度，浮点数，范围为90 ~ -90
    longitude: parseFloat(addObj.longitude) || 116.404, // 经度，浮点数，范围为180 ~ -180。
    name: addObj.storeName || '', // 位置名
    address: addObj.address || '', // 地址详情说明
    scale: 15, // 地图缩放级别,整形值,范围从1~28。默认为最大
    infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
  });
};
// 微信支付
const wxJsBridge = (type = "pay",data,cb)=>{
  function onBridgeReady() {
    if(type === "pay"){
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest', data,
        (res) => {
          if(cb) cb(res);
        }
      );
    }
  }
  if (typeof window.WeixinJSBridge === "object" && typeof window.WeixinJSBridge.invoke === "function") {
    onBridgeReady();
  } else if (document.addEventListener) {
    document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
  } else if (document.attachEvent) {
    // IE浏览器，非W3C规范
    document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
  }
};
// 判断是否小程序
const isMiniProgram = (callback) => {
  if (Object.prototype.toString.call(callback) !== '[object Function]') {
    return;
  }
  // 若为开发环境 则传入false
  if (process.env.NODE_ENV === 'development') {
    callback(false);
    return;
  }
  wx.miniProgram.getEnv((res) => {
    callback(res.miniprogram);
  });
};
// 登录
const login = (reload = false) => {

  // 返回查询参数
  // eslint-disable-next-line no-shadow
  const getSearchStr = (searchParams, reload) => {
    let searchStr = window.location.search;
    const searchTempArr = [];
    // 若reload为true，则为504错误，需要重新OAuth
    // 重走OAuth过程中 redirect_uri参数中不可再有code及userInfo等参数
    if (reload) {
      // eslint-disable-next-line no-restricted-syntax
      for(const key in searchParams) {
        // 过滤code及userInfo参数
        if (key !== 'code' && key !== 'state') {
          searchTempArr.push(`${key}=${searchParams[key]}`);
        }
      }
    }
    if (searchTempArr.length > 0) {
      searchStr = `?${searchTempArr.join('&')}`;
    }
    return searchStr;
  };
  if(!window.sayhi.isApp && process.env.NODE_ENV === 'development') {
    // 开发环境
    return new Promise((resolve) => {
      api.loginMock({
        user_id: 5828710
      }).then((data) => {
        // eslint-disable-next-line no-console
        console.info('登陆成功', data);
        // 获取页面路由
        let route = window.localStorage.getItem('pageRoute');
        if (!route) {
          route = (window.location.hash === '#/' || !window.location.hash) ? '#/v3home' : window.location.hash;
        }
        // 获取链接参数
        const searchParams = getUrlParams();
        // 获取链接查询参数字符串
        const searchStr = getSearchStr(searchParams, reload);
        // 存储页面路由
        window.localStorage.setItem('pageRoute', route);
        // 获取参数
        const params = {
          version: 2,
          frontend_url: `${window.location.protocol}//${window.location.host}${window.location.pathname}${searchStr}`,
          code: searchParams.code
        };
        // 微信登陆
        api.login(params).then((response) => {
          // let response = data ? data.data : data;
          const code = Number(response.code);
          if (code === 302) {
            // 跳转微信验证
            window.location.href = response.data.authUrl;
          } else if (code === 0) {
            // 埋点 获取用户信息
            admaster(response.data.user);
            window.mm = {
              id: response.data.user.user.id,
              active: response.data.user.user.is_active,
              subscribed: response.data.user.user_relation.is_subscribed,
              level_id: response.data.user.user.level_id,
              app_id: response.data.js_config.appId
            };
            // 修改当前路由
            window.location.hash = route || window.location.hash;
            // 清空存储路由
            window.localStorage.removeItem('pageRoute');
            // 成功回调
            resolve();
          } else {
            const message = code === 700 ? response.message : '系统繁忙';
            Modal.alert('温馨提示', message, [
              {
                text: '返回',
                style: { color: '#333' }
              }
            ]);
          }
        });
      });
    });
  } 
    // 线上环境
    return new Promise((resolve) => {
      // 获取页面路由
      let route = window.localStorage.getItem('pageRoute');
      if (!route) {
        route = (window.location.hash === '#/' || !window.location.hash) ? '#/v3home' : window.location.hash;
      }
      // 获取链接参数
      const searchParams = getUrlParams();
      // 获取链接查询参数字符串
      const searchStr = getSearchStr(searchParams, reload);
      // 存储页面路由
      window.localStorage.setItem('pageRoute', route);
      // 获取参数
      const params = {
        version: 2,
        frontend_url: `${window.location.protocol}//${window.location.host}${window.location.pathname}${searchStr}`,
        code: searchParams.code
      };
      // 若reload参数为true，便重走oauth
      if (reload) {
        params.userInfo = undefined;
        params.code = undefined;
      }
      // 微信登陆
      api.login(params).then((response) => {
        // let response = data ? data.data : data;
        const code = Number(response.code);
        if (code === 302) {
          // 跳转微信验证
          window.location.href = response.data.authUrl;
        } else if (code === 0) {
          // 埋点 获取用户信息
          admaster(response.data.user);
          // 获取配置微信SDK参数
          // eslint-disable-next-line camelcase
          const {js_config} = response.data;
          js_config.jsApiList = [
            'chooseWXPay', 'hideMenuItems', 'previewImage',
            'chooseImage', 'uploadImage', 'onMenuShareTimeline',
            'onMenuShareAppMessage', 'getLocation', 'openLocation',
            'scanQRCode', 'updateAppMessageShareData', 'updateTimelineShareData'
          ];
          js_config.openTagList = [ 'wx-open-launch-weapp' ]; // 可选，需要使用的开放标签列表
          window.mm = {
            id: response.data.user.user.id,
            active: response.data.user.user.is_active,
            subscribed: response.data.user.user_relation.is_subscribed,
            level_id: response.data.user.user.level_id,
            app_id: js_config.appId
          };
          // 配置微信SDK
          wx.config(js_config);
          // 修改当前路由
          window.location.hash = route || window.location.hash;
          // 清空存储路由
          window.localStorage.removeItem('pageRoute');
          // wx sdk ready
          wx.ready(() => {
            wx.hideOptionMenu();
            // 成功回调
            resolve();
          });
          // wx sdk error
          wx.error(() => {
            
          });
        } else {
          const message = code === 700 ? response.message : '系统繁忙';
          Modal.alert('温馨提示', message, [
            {
              text: '返回',
              style: { color: '#333' }
            }
          ]);
        }
      });
    });
  
};
// 设置sessionStorage
const setSession = (key,value) => {
  window.sessionStorage.setItem(key, JSON.stringify(value));
};
// 获取sessionStorage
const getSession = (key) => {
  const str = window.sessionStorage.getItem(key) || null;
  return str ? JSON.parse(str) : false;
};
// 设置localStorage
const setLocalStorage = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value));
};
// 获取localStorage
const getLocalStorage = (key) => {
  const info = window.localStorage.getItem(key);
  return info ? JSON.parse(info) : null;
};
// v3.0 模板跳转
const redirectUrlPush = (params) => {
  let type = params.redirectType || '';
  let index = params.resourceIndex || '';
  const id = params.redirectNo || '';
  const prodAttr = params.productAttr || '';
  const {resourceName} = params;
  const {history} = params;
  // 搜索所需参数
  const keyword = params.resourceName || '';
  type = Number(type);
  const pickTypeObj = {
    0: 'chi',
    1: 'zhu',
    2: 'xing',
    3: 'you',
    4: 'gou',
    5: 'yu',
    6: 'wen',
    8: 'others'
  };
  switch(type){
    case 0: 
      // 产品详情
      if (Number(params.resourceType) === 1) {
        // 跳转至秒杀
        history.push(`/secondkill/${id}`);
        return;
      }
      history.push(`/product/1/${prodAttr || 1}/${id}`);
      break;
    case 1:
      // 品牌
      history.push(`/brand/${id}`);
      break;
    case 2:
      // 卡券
      history.push(`/coupons?type=${index}`);
      break;
    case 3:
      // 门店详情
      history.push(`/v3store/${id}`);
      break;
    case 4: {
      // 内部浏览器
      // 若redirectNo字段包含***字符
      // 则取***后面的字符串为跳转链接
      // 若没有***字符 则使用原有规则
      const hasWxUrl = id.indexOf('***');
      const url = hasWxUrl !== -1 ? id.split('***')[1] : id;
      if (hasWxUrl === -1) {
        const searchArr = [
          'shouzhu', 'weifang', 'one-point',
          'H5/one', 'app/fortydiscount', 'app/topproduct'
        ];
        const routeArr = ['/firsthouse', '/lasthouse', '/one', '/one', '/fortydiscount', '/topproduct'];

        // eslint-disable-next-line no-shadow
        let i = 0; const {length} = searchArr; let index = -1;
        for (i; i < length; i += 1) {
          if (url.indexOf(searchArr[i]) !== -1) {
            index = i;
            break;
          }
        }

        if (index !== -1) {
          history.push(routeArr[index]);
          return;
        }
      }
      window.location.href = url;
      break;
    }
    case 19: // 外部浏览器
      window.location.href = id;
      break;
    case 5:
      // 套包
      history.push(`/product/2/${id}`);
      break;
    case 7:{
      // 搜索列表
      const searchParams = {
        keyword, // 关键字
        lat: '', // 经纬度
        lng: '',
        searchType: '', // 业态
      };
      setSession('SEARCH/PARAMS', searchParams);
      history.push(`/search?type=${index}`);        
      break;
    }
    case 9:
      // 主页 0首页 1精选 2花积分 3我的
      index = index > 3 ? 0 : index;
      history.push(`/homepage/${index}`);
      break;
    case 10:
      // 积分
      history.push(`/mypoint?point=${index}`);
      break;
    case 11:
      // 积分明细
      history.push(`/mypoint`);
      break;
    case 14:
      // 邀请好友
      history.push(`/invitation`);
      break;
    case 15:
      // 会员权益
      history.push(`/memberrights`);
      break;
    case 16:
      // 订单
      history.push(`/myorder?order=${index}`);
      break;
    case 20:
      // 资料编辑
      history.push(`/userinfo`);
      break;
    case 22:
      // 会员专区
      history.push(`/special`);
      break;
    case 23:
      // 员工专区
      history.push(`/family`);
      break;
    case 26:
      // 会员轨迹
      history.push(`/profile`);
      break;
    case 27:
      // 专题
      history.push(`/themepage/${index}?subjectId=${id}`);
      break;
    case 28:
      // 资讯  列表
      history.push(`/news?type=${Number(index) + 1}`);
      break;
    case 30:
      // 精选
      history.push(`/pick?type=${pickTypeObj[index]}`);
      break;
    case 31:{
      // 搜索 searchpage
      const pickType = getSession('searchPickType') || '';
      history.push(`/searchPage/${keyword}/${pickType}`);
      break;
    }
    case 32:
      // 资讯详情
      history.push(`/news/${id}`);
      break;
    case 35:
      // 商圈专题
      history.push(`/shop/${id}?tradeAreaName=${resourceName}`);
      break;
    case 6:
    case 8:
    case 12:
    case 13:
    case 17:
    case 18:
    case 21:
    case 24:
    case 25:
      // 6:分类列表 8:品牌墙 12:分享 13:消息 17:我的预约 18我的收藏 21:首住支付 24:我的评价 25:联系客服
      Modal.alert('温馨提示', '网页版暂未开通哦，您可以下载首客首享APP查看此功能。');
      break;
    case 99:
      Modal.alert('温馨提示', '网页版暂未开通哦，您可以搜索首客首享小程序查看此功能。');
      break;
    default: 
      Modal.alert('温馨提示', '网页版暂未开通哦，您可以搜索首客首享小程序查看此功能。');
  }
};
// 获取小程序页面路径
const getMiniAppUrl = (params) => {
  const { redirectType: type = '', resourceIndex = '', redirectNo: id = '', resourceName = '', specialSubjectType = '' } = params;
  // let type = params.redirectType || '';
  let index = resourceIndex || '';
  // const id = params.redirectNo || '';
  // let resourceName = params.resourceName;
  // 搜索所需参数
  const keyword = resourceName || '';
  let url = '';
  switch (+type) {
    case 0:
      // 产品详情
      if (Number(params.resourceType) === 1) {
        // 跳转至秒杀
        url =  `/pages/product/index?id=${id}&type=flash`;
        break;
      }
      // 1 普通专题 2 满减专区 3 领券专题 4 UBR专题 5 主题活动 6 环球主题
      if (+specialSubjectType === 1) {
        url = `/pages/theme/index?subjectType=${index}&subjectId=${id}`;
        break;
      } else if (+specialSubjectType === 2) {
        url = `/sub-sale/pages/index?subjectId=${id}`;
        break;
      } else if (+specialSubjectType === 3) {
        url = `/sub-coupon/pages/get-coupons/index?subjectId=${id}`;
        break;
      } else if (+specialSubjectType === 4) {
        url = `/sub-ubr/pages/theme/index?id=${id}`;
        break;
      } else if (+specialSubjectType === 5) {
        url = `/sub-marketing-theme/pages/subject/index?id=${id}`;
        break;
      } else if (+specialSubjectType === 6) {
        url = `/sub-marketing-theme/pages/ubr-warmup/index?id=${id}`;
        break;
      }
      url = `/pages/product/index?id=${id}${resourceName ? `&resourceName=${resourceName}` : ''}`;
      break;
    case 1:
      // 品牌
      url = `/pages/brand/index?id=${id}`;
      break;
    case 2:
      // 卡券
      const typeArr = [0, 1, 3, 2];
      url = `/pages/member/coupons/index?type=${typeArr[index]}`;
      break;
    case 3:
      // 门店详情
      url = `/pages/store/detail/index?id=${id}`;
      break;
    case 4: // 内部浏览器
      // 若redirectNo字段包含***字符
      // 则取***后面的字符串为跳转链接
      // 若没有***字符 则使用原有规则
      const hasWxUrl = id.indexOf('***');
      const newUrl = hasWxUrl !== -1 ? id.split('***')[1] : id;
      // 判断newurl是不是含有下面几个的页面  就直接跳小程序 其他的跳webview
      const searchArr = [
        'shouzhu', 'weifang', 'firsthouse', 'lasthouse', 
        'one-point','H5/one', 'app/topproduct', 'topproduct', 
        'one', 'guidelist', 'guidelist/storelist', 'guide',
        'sub-activity/pages/coupon-center/index'
      ];
      // app/topproduct  跳专题页
      const routeArr = [
        '/sub-house/pages/index?type=0', '/sub-house/pages/index?type=1', 
        '/sub-house/pages/index?type=0', '/sub-house/pages/index?type=1', 
        '/sub-one/pages/index', '/sub-one/pages/index', 
        '/pages/theme/index?subjectType=2', '/pages/theme/index?subjectType=2', 
        '/sub-one/pages/index', '/sub-guide/pages/store-list/index',
        '/sub-guide/pages/store-list/index', '/sub-guide/pages/cloud-shopo-list/index',
        '/sub-activity/pages/coupon-center/index'
      ];

      let i = 0;
      const { length } = searchArr;
      let pageIndex = -1;
      for (i; i < length; i += 1) {
        if (newUrl.indexOf(searchArr[i]) !== -1) {
          pageIndex = i;
          break;
        }
      }

      if (pageIndex !== -1) {
        url = routeArr[pageIndex];
      }else {
        url = `/pages/webview/index?route=${encodeURIComponent(newUrl)}`;
      }
      break;
    case 19: // 外部浏览器
      url = `/pages/webview/index?route=${encodeURIComponent(id)}`;
      break;
    case 5:
      // 套包
      url = `/sub-package-product/pages/index?id=${id}`;
      break;
    case 7:
      url = `/pages/search/search-result/index?search=${keyword}&type=${index}`;
      break;
    case 9:
      // 主页 0首页 1精选 2花积分 3我的
      index = index > 3 ? 0 : index;
      const arr = ['/pages/home/index', '/pages/pick/index', '/pages/paypoint/index', '/pages/member/index'];
      url = arr[index];
      break;
    case 10:
      // 积分
      url = `/pages/member/my-point/index?point=${index}`;
      break;
    case 11:
      // 积分明细
      url = `/pages/member/my-point/index`;
      break;
    case 14:
      // 邀请好友
      url = `/pages/member/invitation/index`;
      break;
    case 15:
      // 会员权益
      url = `/pages/member/member-rights/index`;
      break;
    case 16:
      // 订单
      url = `/pages/member/my-order/index?type=${index}`;
      break;
    case 20:
      // 资料编辑
      url = `/pages/member/user-info/index`;
      break;
    case 22:
      // 会员专区
      url = `/sub-special/pages/index`;
      break;
    case 23:
      // 员工专区
      url = `/sub-family/pages/index`;
      break;
    case 26:
      // 会员轨迹
      url = `/pages/member/index`;
      break;
    case 27:
      // 专题
      // 1 普通专题 2 满减专区 3 领券专题 4 UBR专题 5 主题活动 6 环球主题
      if (+specialSubjectType === 1) {
        url = `/pages/theme/index?subjectType=${index}&subjectId=${id}`;
        break;
      } else if (+specialSubjectType === 2) {
        url = `/sub-sale/pages/index?subjectId=${id}`;
        break;
      } else if (+specialSubjectType === 3) {
        url = `/sub-coupon/pages/get-coupons/index?subjectId=${id}`;
        break;
      } else if (+specialSubjectType === 4) {
        url = `/sub-ubr/pages/theme/index?id=${id}`;
        break;
      } else if (+specialSubjectType === 5) {
        url = `/sub-marketing-theme/pages/subject/index?id=${id}`;
        break;
      } else if (+specialSubjectType === 6) {
        url = `/sub-marketing-theme/pages/ubr-warmup/index?id=${id}`;
        break;
      }
      url = `/pages/theme/index?subjectType=${index}&subjectId=${id}`;
      break;
    case 28:
      // 资讯  列表
      url = `/pages/news/index?type=${Number(index) + 1}`;
      break;
    case 30:
      // 精选
      url = `/pages/pick/index`;
      break;
    case 31:
      // 搜索 searchpage
      url = `/pages/search/index`;
      break;
    case 32:
      // 资讯详情
      url = `/pages/news/detail/index?id=${id}`;
      break;
    case 35:
      // 商圈专题
      url = `/sub-trading-area/pages/detail/index?tradeAreaId=${id}&tradeAreaName=${resourceName}`;
      break;
    case 37:
      // 直播
      url = `plugin-private://wx2b03c6e691cd7370/pages/live-player-plugin?room_id=${id}`;
      break;
    case 38:
      // 跳转小程序
      const { pageWay } = params;
      url = pageWay;
      break;
    case 99:
      url = '/sub-pintuan/pages/product-list/index';
      break;
    case 100:
      // 满减专区
      url = `/sub-sale/pages/index?subjectId=${id}`;
      break;
    case 101:
      // 领券专题
      url = `/sub-coupon/pages/get-coupons/index?subjectId=${id}`;
      break;
    case 102:
      // 助力活动
      url = `/sub-help-activity/pages/index?actId=${id}`;
      break;
    case 103:
      // 环球专题
      url = `/sub-ubr/pages/theme/index?id=${id}`;
      break;
    case 104:
      // 5 主题活动 6 环球主题
      if (+specialSubjectType === 5) {
        url = `/sub-marketing-theme/pages/subject/index?id=${id}`;
      } else if (+specialSubjectType === 6) {
        url = `/sub-marketing-theme/pages/ubr-warmup/index?id=${id}`;
      }
      break;
    case 105:
      // 首客打包产品
      url = `/sub-ubr/pages/package-product/index?id=${id}`;
      break;
    case 106:
      // eb酒店
      url = '/sub-ubr/pages/eb-hotel/index';
      break;
    case 107:
      // 兑换中心
      url = `/pages/member/exchange/index`;
      break;
    case 6:
    case 8:
    case 12:
    case 13:
    case 17:
    case 18:
    case 21:
    case 24:
    case 25:
      // 6:分类列表 8:品牌墙 12:分享 13:消息 17:我的预约 18我的收藏 21:首住支付 24:我的评价 25:联系客服
      // 小程序暂未开通哦，您可以下载首客首享APP查看此功能。
      url = '';
      break;
    default:
      url = '';
      break;
  }
  return url;
};

// 获取经纬度
const getLocation = () => 
  // 返回的status代表处理状态
   new Promise(resolve => {
    // 天安门经纬度
    const data = {
      lng: '116.396506',
      lat: '39.910038',
      status: 1
    };
    if (!window.sayhi.isWX) { // 不是微信环境，使用默认经纬度
      setSession('USER/POSITION', data);
      resolve(data);
    } else {
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        complete: (res) => {
          if (res.errMsg === 'getLocation:ok') {
            const { longitude, latitude } = res;
            data.lng = longitude || '116.396506';
            data.lat = latitude || '39.910038';
            data.status = 1;
            setSession('USER/POSITION', data);
            resolve(data);
          } else {
            data.status = 0;
            setSession('USER/POSITION', data);
            resolve(data);
          }
        }
      });
    }
  })
;
// 获取当前定位(高德)
const getLocationByAMap = (callback) => {
  // 成功完成定位需要达成以下前提条件:
  // 1.系统GPS打开
  // 2.所使用的App或浏览器已获取定位权限
  // 3.对打开的页面允许使用定位
  // 4.对于iOS10以上系统和Android的一些版本已禁止在非HTTPS协议的域名下定位，请尽快将站点升级到HTTPS
  const {AMap} = window;
  AMap.service(["AMap.Geolocation"], () => {
    const geoLocation = new AMap.Geolocation();
    // callback:function(status, result)
    // status: 'complete'(定位成功) | 'error'(定位失败)
    // result: 返回结果 返回值参考高德地图文档
    // https://lbs.amap.com/api/javascript-api/reference/location#m_AMap.Geolocation
    geoLocation.getCurrentPosition(callback);
  });
};
// 产品价钱
const price = (pricep, point, attr) => {
  let text = 0;
  const str = Number(attr) === 6 || Number(attr) === 7 ? '起' : '';
  if (pricep && parseFloat(pricep) > 0) {
    text = `¥${parseFloat(pricep)}`;
  }
  if (point && point > 0) {
    if (text) {
      text += `+${point}积分`;
    } else {
      text = `${point}积分`;
    }
  }
  return text + str;
};
// 调支付  钱 钱和积分 积分
const pay = (params) => {
  //  jcqData = {prodName: 'fd'}
  // payType 1：积分   2：钱+积分   3：钱

  const { requestParams, goPage, jcqData, cancelOrder} = params;
  const { orderPoints, orderAmount } = requestParams;
  let payType = '';
  if(Number(orderAmount) === 0 && Number(orderPoints) === 0 ){
    const wjcqData = {
      ...jcqData,
      msg_title: '温馨提示',
      msg: '该产品不能购买'
    };
    window._sksx.push(['_track', 'ptcpxq_window', wjcqData]);
    Modal.alert('温馨提示', '该产品不能购买', [{text: '确定', onPress: ()=>{
      window._sksx.push(['_track', 'ptcpxq_window', {
        ...wjcqData, button_name: '确定'
      }]);
      window.location.reload();
    }}]);
  }else if(Number(orderAmount) === 0 && Number(orderPoints) > 0 ){
    payType = 1;
  }else if(Number(orderAmount) > 0 && Number(orderPoints) === 0 ){
    payType = 3;
  }else if(Number(orderAmount) > 0 && Number(orderPoints) > 0 ){
    payType = 2;
  }
  return new Promise((resolve)=>{
    const reqData = {
      ...requestParams,
      productType: payType
    };
    if (window.sayhi.isBtgApp) {
      api.payOrder(reqData).then((res) => {
        Toast.hide();
        if(res.code === 0){
          const {data} = res;
          window.sayhi.pub('onAppCall', {
            name: 'payOrder',
            params: { orderId: data.orderId, payAmount: orderAmount, payPoints: orderPoints },
            callback: 'appPayCallback'
          });
          window.sayhi.sub('appPayCallback', () => {
            window.setTimeout(()=> {resolve()}, 500); 
          });
        }
      });
      return;
    }

    isMiniProgram((isMini)=>{
      if(isMini){
        reqData.isMiniApp = 1;
      }
      api.payOrder(reqData).then((res) => {
        Toast.hide();
        if(res.code === 0){
          const {data} = res;
          if (window.sayhi.isBtgApp) {
            window.sayhi.pub('onAppCall', {
              name: 'payOrder',
              params: { orderId: data.orderId, payAmount: orderAmount, payPoints: orderPoints },
              callback: 'appPayCallback'
            });
            window.sayhi.sub('appPayCallback', () => {
              window.setTimeout(()=> {resolve()}, 500); 
            });
            return;
          }
          if(payType === 1){
            //  纯积分支付
            const wjcqData = {
              ...jcqData,
              msg_title: '温馨提示',
              msg: '支付成功',
              product_type: payType,
              order_id: data.orderId,
            };
            window._sksx.push(['_track', 'ptcpxq_window', wjcqData]);
            // eslint-disable-next-line no-unused-expressions
            typeof goPage === 'function' && goPage(`/paysuccess?payAmount=${orderAmount || 0}`);
          }else if(isMini){
            const searchStr = [];
            for (const key in data) {
              let value = data[key];
              if (key === 'package') {
                value = value.replace('prepay_id=', '');
              }
              searchStr.push(`${key}=${value}`);
            }
            const hash = window.location.hash.slice(2);
            searchStr.push(`redirect=${encodeURIComponent(hash)}`);
            if (process.env.NODE_ENV === 'development') {
              resolve();
              return;
            }
            wx.miniProgram.navigateTo({
              url: `/pages/pay/index?${searchStr.join('&')}`,
              success: () => resolve()
            });
          }else{
            // eslint-disable-next-line no-shadow
            wxJsBridge('pay', data, (res)=>{
              if(res.err_msg === "get_brand_wcpay_request:ok" ) {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                // res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
                const wjcqData = {
                  ...jcqData,
                  msg_title: '温馨提示',
                  msg: '支付成功',
                  product_type: payType,
                  order_id: data.orderId,
                };
                window._sksx.push(['_track', "ptcpxq_window", wjcqData]);
                // eslint-disable-next-line no-unused-expressions
                typeof goPage === 'function' && goPage(`/paysuccess?payAmount=${orderAmount || 0}`);
              }else if(res.err_msg === "get_brand_wcpay_request:cancel"){
                const wjcqData = {
                  ...jcqData,
                  msg_title: '温馨提示',
                  msg: '支付不成功，请重新支付',
                  product_type: payType,
                  order_id: data.orderId,
                };
                window._sksx.push(['_track', "ptcpxq_window", wjcqData]);

                // 取消订单
                // eslint-disable-next-line no-unused-expressions
                cancelOrder && cancelOrder(data.orderId);

                Modal.alert('温馨提示', '支付不成功，请重新支付', [
                  { text: '返回', onPress: () => {
                    window._sksx.push(['_track', "ptcpxq_window", {
                      ...wjcqData,
                      button_name: '返回'
                    }]);
                    resolve();
                  }}
                ]);
              }else if(res.err_msg === "get_brand_wcpay_request:fail"){
                const wjcqData = {
                  ...jcqData,
                  msg_title: '温馨提示',
                  msg: '支付失败',
                  product_type: payType,
                  order_id: data.orderId,
                };

                // 取消订单
                // eslint-disable-next-line no-unused-expressions
                cancelOrder && cancelOrder(data.orderId);

                window._sksx.push(['_track', "ptcpxq_window", wjcqData]);
                Modal.alert('温馨提示', '支付失败', [
                  { text: '返回', onPress: () => {
                    window._sksx.push(['_track', "ptcpxq_window", {
                      ...wjcqData,
                      button_name: '返回'
                    }]);
                    resolve();
                  }}
                ]);
              }else if(res.err_msg === "调用支付JSAPI缺少参数：total_fee"){
                const wjcqData = {
                  ...jcqData,
                  msg_title: '温馨提示',
                  msg: '请检查预支付会话标识prepay_id是否已失效',
                  product_type: payType,
                  order_id: data.orderId,
                };

                // 取消订单
                // eslint-disable-next-line no-unused-expressions
                cancelOrder && cancelOrder(data.orderId);

                window._sksx.push(['_track', "ptcpxq_window", wjcqData]);
                Modal.alert('温馨提示', '请检查预支付会话标识prepay_id是否已失效', [
                  { text: '返回', onPress: () => {
                    window._sksx.push(['_track', "ptcpxq_window", {
                      ...wjcqData,
                      button_name: '返回'
                    }]);
                    resolve();
                  }, style: {color: '#333'} }
                ]);
              }
            });
          }
        }else{
          // 接口返回错误信息
          const wjcqData = {
            ...jcqData,
            msg_title: '温馨提示',
            msg: res.message,
            product_type: payType,
          };
          window._sksx.push(['_track', "ptcpxq_window", wjcqData]);
          Modal.alert('温馨提示', res.message, [
            { text: '返回', onPress: () => {
              window._sksx.push(['_track', "ptcpxq_window", {
                ...wjcqData,
                button_name: '返回'
              }]);
              resolve();
            }, style: {color: '#333'} }
          ]);
        }
      });
    });

  });


};
// 设置cookie 过期时间为秒
const setCookie = (key, value, second) => {
  const date = new Date();
  date.setTime(date.getTime() + second * 1000);
  document.cookie = `${key}=${encodeURIComponent(value)};${second ? `expires=${date.toUTCString()}` : ''}`;
};
// 获取cookie
const getCookie = (key, decode = true) => {
  const {cookie} = document;
  const index = cookie.indexOf(key);
  if (index !== -1) {
    const start = index + key.length + 1;
    let end = cookie.indexOf(';', start);
    end = end < 0 ? cookie.length : end;
    const value = cookie.substring(start, end);
    return decode ? decodeURIComponent(value) : value;
  }
  return '';
};
// 获取当前风格
const getCurrentTheme = () => {
  const now = +new Date();
  const christmasStart = +new Date('2019/12/23');
  const newyearStart = +new Date('2019/12/26');
  const newyearEnd = +new Date('2020/1/3');
  const chunjieStart = +new Date('2020/1/15');
  const chunjieEnd = +new Date('2020/2/9');
  if (now >= christmasStart && now < newyearStart) {
    return 'christmas';
  }
  if (now >= newyearStart && now <= newyearEnd) {
    return 'newyear';
  }
  if (now >= chunjieStart && now <= chunjieEnd) {
    return 'chunjie';
  }
  return 'normal';
};

// 发送信息到APP
const postMessageToApp = (messageName, payload = []) => {
  if (typeof messageName !== 'string' || !Array.isArray(payload)) {
    throw new Error('The first parameter must be a string and the second parameter must be an Array');
  }
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  if (isAndroid) {
    try {
      window.btg[messageName](...payload);
    } catch (e) {
      // dosomething
    }
  } else {
    try {
      window.webkit.messageHandlers[messageName].postMessage(payload);
    } catch (e) {
      // dosomething
    }
  }
};

// 埋点方法
const sksxTrack = (eventName, properties = {}) => {
  postMessageToApp('JsToAppBtgTrack', [JSON.stringify({
    eventName,
    properties: JSON.stringify(properties)
  })]);
};

const setBtgRedirectUrl = (obj) => {
  let btgUrl = `btg://resource=${JSON.stringify(obj)}`;
  // 获取链接参数
  const hashSearch = window.location.hash.split('?')[1];
  const { iosPolicy } = hashSearch ? getUrlParams(`?${hashSearch}`) : getUrlParams();
  if (iosPolicy) {
    btgUrl = `btg://resource?data=${JSON.stringify(obj)}`;
  }
  return encodeURI(btgUrl);
};

/**
 * 转换时间格式
 */
const getFormatDate = (d, format) => {
  const date = new Date(d);
  const objArr = [
    {
      reg: 'M+',
      value: date.getMonth() + 1
    },
    {
      reg: 'd+',
      value: date.getDate()
    },
    {
      reg: 'h+',
      value: date.getHours()
    },
    {
      reg: 'm+',
      value: date.getMinutes()
    },
    {
      reg: 's+',
      value: date.getSeconds()
    }
  ];
  // 将format中的 yyyy||yy 更改成 getFullYear()
  const yearReg = new RegExp('(y+)', 'i');
  if (yearReg.test(format)) {
    const yearExec = yearReg.exec(format)[0];
    format = format.replace(yearExec, (date.getFullYear() + '').substring(4 - yearExec.length));
  }
  // 将剩余的format字符串转换为时间
  let i = 0;
  const { length } = objArr;
  for (i; i < length; i += 1) {
    // eslint-disable-next-line space-infix-ops
    const timeReg = new RegExp('('+ objArr[i].reg +')');
    if (timeReg.test(format)) {
      const timeExec = timeReg.exec(format)[0];
      const value = objArr[i].value + '';
      format = format.replace(timeExec, timeExec.length <= 1 ? value : ('00' + value).substring(value.length));
    }
  }
  return format;
};

/**
 * 获取运行环境
 */
const getCurrentEnv = () =>
  new Promise(resolve => {
    // 微信
    if (window.iswx) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          resolve('miniapp');
          return;
        }
        resolve('wx');
      });
      return;
    }
    const ua = navigator.userAgent.toLowerCase();
    // 抖音或百度小程序需要单引sdk且只能引入一次
    const istt = ua.match(/toutiaomicroapp/i);
    if (istt || window.isTTWebView) {
      resolve('ttminiapp');
      return;
    }
    // 百度小程序
    const isbd = ua.match(/swan/i);
    if (isbd) {
      resolve('bdminiapp');
      return;
    }
    // 安卓
    if (ua.match('android') || ua.match('linux')) {
      resolve('Android');
      return;
    }
    // iOS
    if (/(iphone|ipad|ipod|ios)/i.test(ua)){
      resolve('iOS');
      return;
    }
    return 'others';
  });

export default {
  getUrlParams, 
  sumPrice,
  wxShareConfig,
  admaster,
  wxOpenLocation,
  wxJsBridge,
  isMiniProgram,
  login,
  setSession,
  getSession,
  setLocalStorage,
  getLocalStorage,
  redirectUrlPush,
  getMiniAppUrl,
  getLocation,
  getLocationByAMap,
  price,
  pay,
  setCookie,
  getCookie,
  getCurrentTheme,
  postMessageToApp,
  sksxTrack,
  jsonParse,
  setBtgRedirectUrl,
  getFormatDate,
  getCurrentEnv
};